<template>
  <div class="ims-tip" v-if="show">
    <main>
      <h2 v-if="title">{{ title }}</h2>
      <slot />
    </main>
    <ims-button type="clear" class="btn-icon" @click="hide()">
      <ims-icon icon="close" />
    </ims-button>
  </div>
</template>

<script>
import md5 from "md5";
import Storage from "../../modules/storage/storage";
let tipStorage = new Storage("hide-tips");

export default {
  data() {
    return {
      show: false
    };
  },
  props: {
    title: {
      type: String,
      default: null
    }
  },
  methods: {
    hide() {
      tipStorage.set("tip-" + this.id, true);
      this.show = false;
    }
  },
  computed: {
    /**
     * Generate a Unique ID for this specific Tip
     * We do this by maping each node text to a single string
     * then hashing that for an ID
     */
    id() {
      let data = this.$slots.default
        .map(node => {
          return node.text;
        })
        .join("|");
      // return a shortish ID from the slots text -
      return md5(data).substr(0, 10);
    }
  },
  mounted() {
    this.show = tipStorage.get("tip-" + this.id) ? false : true;
  }
};
</script>

<style lang="scss">
@import "../../scss/utils/variables";
.ims-tip {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0px 0;
  background-color: $yellow-fade;
  border: solid 1px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 16px;
  font-size: $font-sm;
  line-height: 120%;
  .btn-icon {
  }
  &.no-border {
    border: none;
  }
  &.square {
    border-radius: 0;
  }
  main {
    margin-right: 10px;
    flex-grow: 1;
  }
  h2 {
    font-size: $font-md;
    font-weight: bold;
    margin-bottom: 0;
    margin-right: 10px;
  }
}
</style>
